export default __webpack_public_path__ + "static/media/ic_folder.dec6ec55.svg";